var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('img',{attrs:{"src":_vm.$auth.user.picture}}),_c('h2',[_vm._v(_vm._s(_vm.$auth.user.name))]),_c('p',[_vm._v(_vm._s(_vm.$auth.user.email))])]),_c('div',[_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.$auth.claims, null, 2)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }